import { sortTableRow } from "./sortTableRow";

  // Agrupa as alternativas por enunciado
  export const groupAlternativesByTitle = (alternativas) => {
    const groups = {};
    alternativas.forEach((alternativa) => {
      if (!groups[alternativa.enunciado]) {
        groups[alternativa.enunciado] = [];
      }
      groups[alternativa.enunciado].push(alternativa);
    });
    
    // Ordena as alternativas dentro de cada grupo
    Object.keys(groups).forEach((enunciado) => {
      groups[enunciado] = sortTableRow(groups[enunciado]);
    });
    
    return groups;
  };